import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";

export default class EditSponsorBlockDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {languages.tournament.editSponsorBlock}
        </DialogTitle>
        <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
          <DialogContentText />
          <TextField
            autoFocus
            margin="dense"
            label={languages.general.name}
            value={this.props.name}
            name="name"
            onChange={this.props.handleChange}
            type="text"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.toggleDialog} color="primary">
            {languages.general.cancel}
          </Button>
          <Button
            onClick={this.props.handleSubmit}
            variant="contained"
            color="primary"
            type="submit"
          >
            {languages.general.save}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
